(() => {
  const namespace = 'PTTBuildingBricksHotspots';
  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }
  const initialized = new WeakSet();
  const init = (root) => {
    root.querySelectorAll('hotspots-image[data-ptt-bricks-hotspots]').forEach((scene) => {
      if (initialized.has(scene)) return;
      if (typeof scene.closeActiveHotspot !== 'function') return;
      initialized.add(scene);
      if (scene.activeHotspot && scene.keyUpHandler) {
        document.removeEventListener('keyup', scene.keyUpHandler);
      }
      scene.handleKeyup = (event) => {
        if (event.key !== 'Escape' || !scene.activeHotspot) return;
        const trigger = scene.activeHotspot.querySelector('.hotspot__btn');
        scene.closeActiveHotspot(event);
        if (trigger) trigger.focus({ preventScroll: true });
      };
      if (scene.activeHotspot) {
        scene.keyUpHandler = scene.handleKeyup;
        document.addEventListener('keyup', scene.keyUpHandler);
      }
    });
  };
  window[namespace] = { init };
  customElements.whenDefined('hotspots-image').then(() => {
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  });
})();
